import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter, unref } from 'vue';

export const useCalendarEventChipsInfo = (enabled: MaybeRefOrGetter<boolean>) => {
  const { getCalendarEventsChips } = useExperienceApi();

  const { data: calendarEvents } = useQuery({
    queryKey: ['CalndarEventChipsInfo'],
    queryFn: () => {
      return getCalendarEventsChips();
    },
    select: (response) => response.data,
    enabled: computed(() => !!unref(enabled)),
  });

  return {
    calendarEvents,
  };
};
